/**
 * Alaska: App.js (PWA)
 * Store: Documents
 * @version 1.0
 */

document.addEventListener("alpine:init", () => {
    Alpine.store("documents", {
        handbooks: [],
        policies: [],
        loading: false,

        fetch_documents: async function () {
            Debug.log("Fetching handbooks...", "warning");

            this.loading = true;
            this.handbooks = [];
            this.policies = [];

            try {
                const res = await fetch("/", {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify({
                        action: "fetch_documents",
                        controller: "documents"
                    })
                });

                const json = await res.json();

                if (json.type === "success") {
                    json.data.forEach((document) => {
                        switch (document.type) {
                            case "handbook":
                                this.handbooks.push(document);
                                break;
                            case "policy":
                                this.policies.push(document);
                                break;
                        }
                    });
                } else {
                    console.error("Failed to fetch handbooks:", json.message);
                }

            } catch (err) {
                console.error("Error fetching handbooks", err);
            } finally {
                this.loading = false;
            }
        }
    });
});
